<template>
  <div class="container">
    <img src="static/img/top.png" class="bg" alt="" />
    <img src="static/img/jf.png" class="part" alt="" />
    <!-- <div class="right">
      <van-icon name="question-o" color="white" size="18" />
      <p style="margin-left: 5px" @click="show = true">积分规则</p>
    </div> -->
    <div style="margin-top: -16vw">
      <div class="jf">
        <p>当前积分</p>
        <span>{{ score }}.00</span>
      </div>
      <van-list
        v-model="listloading"
        :immediate-check="false"
        :finished="listfinished"
        finished-text="没有更多啦"
        @load="listload_more()"
      >
        <div class="flex" v-for="(item, index) in list" :key="index">
          <div>
            <p>{{ item.memo }}</p>
            <p class="date">{{ timeTrans(item.createtime) }}</p>
          </div>
          <p class="score" v-if="item.after > item.before">+{{ item.score }}</p>
          <p class="score" v-if="item.after < item.before">{{ item.score }}</p>
        </div>
      </van-list>
      <van-overlay :lock-scroll="false" :show="show" @click="show = false">
        <div class="rule">
          <h3>新时代文明实践云平台：可以在积分模块兑换奖励。</h3>
          <p class="tip">
            积分由参与活动时长和云平台活跃程度两部分组成，鼓励志愿者积极参与活动，并积极分享活动，吸引更多市民关注或加入志愿者团队。
          </p>
          <table border="1px solid #f2f2f2" cellpadding="10">
            <tr>
              <th>用户行为</th>
              <th>云平台志愿积分</th>
              <th>每日上限（次数）</th>
              <th>备注</th>
            </tr>
            <tr>
              <td>登陆云平台</td>
              <td>1/次</td>
              <td>1</td>
              <td></td>
            </tr>
            <tr>
              <td>点赞、评论、收藏</td>
              <td>1/次</td>
              <td>5</td>
              <td></td>
            </tr>
            <tr>
              <td>分享到朋友圈</td>
              <td>2/次</td>
              <td>2</td>
              <td></td>
            </tr>
            <tr>
              <td>志愿时长</td>
              <td>100/时</td>
              <td></td>
              <td>完成确认后，自动增加志愿积分</td>
            </tr>
            <tr>
              <td>发布活动报告</td>
              <td>5/次</td>
              <td>不限制</td>
              <td></td>
            </tr>
            <tr>
              <td>活动报告（澄风show)被点赞≥300</td>
              <td>20</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>活动报告（澄风show)被转发≥30</td>
              <td>20</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>每月志愿之星（个人）</td>
              <td>200</td>
              <td></td>
              <td>10个</td>
            </tr>
          </table>
        </div>
      </van-overlay>
    </div>
  </div>
</template>
<script>
export default {
  name: "myjf",
  data() {
    return {
      score: "",
      list: [],
      listpage: 1,
      listloading: false,
      listfinished: false,
      show: false,
    };
  },
  created() {
    this.$axios({
      method: "post",
      url: "/api/home/score_log",
    }).then((res) => {
      console.log(res.data);
      this.score = res.data.data.member.score;
      this.list = res.data.data.list;
    });
  },
  methods: {
    listload_more() {
      this.listpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/home/score_log",
            data: that.qs.stringify({
              page: that.listpage,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              that.list = that.list.concat(res.data.data.list);
            }
            that.listloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listfinished = true;
            } else {
              that.listfinished = false;
            }
          });
      }, 500);
    },
  },
};
</script>
<style scoped>
.bg {
  width: 100%;
  display: block;
}
.right {
  display: flex;
  align-items: center;
  color: white;
  position: absolute;
  right: 5px;
  top: 5px;
}
.jf {
  position: absolute;
  top: 14vw;
  left: 30vw;
  color: white;
}
.jf span {
  font-size: 24px;
  font-weight: bold;
}
.flex {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #eee;
  align-items: center;
}
.date {
  color: #bbbbbb;
  font-size: 14px;
  margin-top: 10px;
}
.score {
  color: orange;
  font-weight: bold;
  font-size: 20px;
}
.rule {
  width: 80%;
  height: 80%;
  margin: 10vh auto;
  background: white;
  padding: 10px;
  overflow: scroll;
  font-size: 14px;
}
.rule .tip {
  font-size: 12px;
}
.rule .tip,
.rule h3 {
  margin: 10px 0;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th,
td {
  padding: 5px;
}
.part {
  position: absolute;
  top: 10vw;
  width: 20vw;
  left: 10vw;
}
</style>


// WEBPACK FOOTER //
// src/components/myjf.vue